// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"30858f54","977":"76ad5f79"}[chunkId] + ".chunk.js";
};